import { render, staticRenderFns } from "./QuestionsForPrint.vue?vue&type=template&id=06ec4d22&"
import script from "./QuestionsForPrint.vue?vue&type=script&lang=js&"
export * from "./QuestionsForPrint.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsForPrint.vue?vue&type=style&index=0&id=06ec4d22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports